const Notification = ({ notification }) => {
  if (!notification) return null;
  return (
    <div className={`alert alert-${notification.type}`}>
      {notification.message}
    </div>
  );
};

export default Notification;
